import script from "./EditBuyers.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBuyers.vue?vue&type=script&setup=true&lang=js"

import "./EditBuyers.vue?vue&type=style&index=0&id=0f96c2af&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f96c2af"]])

export default __exports__